import { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import Guid from "@/app/types/common/guid";
import { RouteBuilder } from "@/app/ui/navigation/routeBuilder";
import { MenuItem } from "@/app/ui/navigation/types";
import { keys } from "@/plugins/i18n";

const builder = new RouteBuilder("Pricing_");

export const priceListSubRoutes = {
  pricesTab: builder.subRouteWithSingleIdParam({
    path: "/pricing/view-price-list/:id/prices",
    component: () =>
      import(
        /* webpackChunkName: "pricing" */ "@/components/pages/prices/viewpricelist/PriceListPricesTab.vue"
      ),
  }),
  discountsTab: builder.subRouteWithSingleIdParam({
    path: "/pricing/view-price-list/:id/discounts",
    component: () =>
      import(
        /* webpackChunkName: "pricing" */ "@/components/pages/prices/viewpricelist/PriceListDiscountsTab.vue"
      ),
  }),
  settingsTab: builder.subRouteWithSingleIdParam({
    path: "/pricing/view-price-list/:id/settings",
    component: () =>
      import(
        /* webpackChunkName: "pricing" */ "@/components/pages/prices/viewpricelist/PriceListSettingsTab.vue"
      ),
  }),
};

export const pricingRoutes = {
  listPriceLists: builder.route({
    url: "/pricing/list-price-lists",
    view: () =>
      import(
        /* webpackChunkName: "pricing" */ "@/components/pages/prices/ListPriceLists.vue"
      ),
    requiredUserPermissions: [EnumUserPermission.priceListsView],
  }),
  viewPriceList: builder.routeToHoldSubRoutes({
    url: "/pricing/view-price-list/:id",
    view: () =>
      import(
        /* webpackChunkName: "pricing" */ "@/components/pages/prices/ViewPriceList.vue"
      ),
    routeKey: (route) => "//pricing/view-price-list/" + route.params.id,
    childRoutes: [
      priceListSubRoutes.pricesTab,
      priceListSubRoutes.discountsTab,
      priceListSubRoutes.settingsTab,
    ],
    requiredUserPermissions: [EnumUserPermission.priceListsView],
  }),
  priceFinder: builder.routeWithParam(
    {
      url: "/pricing/price-finder",
      componentProps: (route) => ({
        initialOutletId:
          Guid.tryParse(route.params.initialOutletId?.toString()) ?? undefined,
      }),
      view: () =>
        import(
          /* webpackChunkName: "pricing" */ "@/components/pages/prices/PriceFinder.vue"
        ),
    },
    (initialOutletId?: Guid) => ({
      initialOutletId: initialOutletId?.toString(),
    })
  ),
  outletsWithOneFree: builder.route({
    url: "/pricing/outlets-with-one-for-free",
    view: () =>
      import(
        /* webpackChunkName: "pricing" */ "@/components/pages/prices/OutletsWithOneForFree.vue"
      ),
  }),
  outletsWithSpecialPricing: builder.route({
    url: "/pricing/outletswithspecialpricing",
    view: () =>
      import(
        /* webpackChunkName: "pricing" */ "@/components/pages/prices/OutletsWithSpecialPricing.vue"
      ),
  }),
};

export const buildPricingMenuItems: () => MenuItem[] = () => [
  MenuItem.forBranch({
    translationKey: keys.navigation_pricing_group.value,
    icon: "MonetizationOn",
    requiredUserPermissions: [EnumUserPermission.menuPricingView],
    subMenus: [
      MenuItem.forRoute(keys.price_lists_list, pricingRoutes.listPriceLists, {
        requiredUserPermissions: [EnumUserPermission.priceListsView],
      }),
      MenuItem.forRoute(keys.price_price_finder, pricingRoutes.priceFinder),
      MenuItem.forRoute(
        keys.bogof_outlets_with_one_for_free,
        pricingRoutes.outletsWithOneFree
      ),
      MenuItem.forRoute(
        keys.bogof_outlets_with_special_pricing,
        pricingRoutes.outletsWithSpecialPricing
      ),
    ],
  }),
];
